import request from '../../utils/request';
import type { WorkspaceUser, UserPermissions } from '@/types';

export interface UpsertUserPayload {
  email: string;
  displayName: string;
  permissions: UserPermissions;
}

/** List all workspace users. */
export function fetchWorkspaceUsers(): Promise<WorkspaceUser[]> {
  return request.get('/api/auth/workspace-users').then((res) => res.data);
}

/** Create a new workspace user. */
export function createWorkspaceUser(payload: UpsertUserPayload): Promise<void> {
  return request.post('/api/auth/workspace-users', payload).then((res) => res.data);
}

/** Update an existing workspace user. */
export function updateWorkspaceUser(id: number, payload: Partial<UpsertUserPayload>): Promise<void> {
  return request.put(`/api/auth/workspace-users/${id}`, payload).then((res) => res.data);
}

/** Delete a workspace user. */
export function deleteWorkspaceUser(id: number): Promise<void> {
  return request.delete(`/api/auth/workspace-users/${id}`).then((res) => res.data);
}
